import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OutcomeReason } from '../@types/sla.type';
import { getAllOutcomeReasons } from '../api/sla';
import { OutcomeReasonsKey } from '../configs/sla';

export const useGetAllOutcomeReasons = (): UseQueryResult<OutcomeReason[]> => {
  return useQuery({
    queryKey: [OutcomeReasonsKey],
    queryFn: () => getAllOutcomeReasons(),
    staleTime: 60 * 60 * 1000
  });
};